import { styled } from "@mui/material/styles";
export const color = {
    key: "palette.action.active",
    index: "palette.action.active",
    string: "error.main",
    symbol: "error.main",
    boolean: "primary.main",
    number: "info.main",
    undefined: "success.main",
    null: "success.main",
    error: "warning.main",
};
export const Code = styled("code", {})({});
//# sourceMappingURL=styles.js.map